export enum Profile {

  Local,
  Dev,
  Prod,
  Hmr

}
